var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFiRrPlus = function SvgFiRrPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23.25,
    height: 23.25,
    x: 0.471,
    y: 0.375,
    stroke: "#2D2F36",
    strokeWidth: 0.75,
    rx: 11.625
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fi-rr-plus_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2D2F36",
    d: "M15.808 15.093 12.714 12l3.094-3.094a.437.437 0 0 0 0-.618.437.437 0 0 0-.619 0l-3.093 3.093-3.094-3.093a.437.437 0 0 0-.619 0 .44.44 0 0 0 0 .618L11.477 12l-3.094 3.093a.438.438 0 0 0 .62.62l3.093-3.094 3.093 3.093a.437.437 0 1 0 .619-.619"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "fi-rr-plus_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.096 4.575 19.52 12l-7.424 7.424L4.67 12z"
  })))));
};
export default SvgFiRrPlus;